module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In the dark of the carriage, the horses’ hooves did nothing to drown out the thunder of Diana Buntin’s heart. The sound filled her ears and vibrated her ribs. Her lungs ached for air, yet the simple act of breathing seemed unattainable.\n")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate, her good friend and once her lady’s companion, squeezed Diana’s hand as the carriage halted. “Dinna fash,” she said, her soft Scottish brogue stronger since she married her highland laird.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hand in hand, they waited for the door to open. “’Tis not too late to change your mind,” Kate murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And what then? Continue her lonely spinster’s existence?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would have married long ago, were it not for the death of her betrothed, followed almost immediately by her elderly parents’ demises, one after the other. She’d done nothing but wait for years. In what had seemed less than a moment, she’d gone from youthful debutante to spinster on the shelf. A horrid fate for a woman who once expected a glittering marriage, home and family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wasn’t it now her turn to taste what life had to offer? Wasn’t it time to stop waiting and seize what she wanted?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Realizing she was gripping Kate’s hand far too hard, she let go. Many women had the kind of discrete liaison she sought. Widows. Unhappily married women. For them, people turned a blind eye. So what if she’d never been married?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Having made her list of potential bed partners from men known by reputation as hedonists who specialized in passion, she’d closed her eyes and let fate take its course. Only Kate knew the name her pin had stabbed. Like the good friend she’d always been, Kate had delivered the offer of one night of anonymous lovemaking. Diana didn’t want to know the man’s identity, she just wanted him to show her the passion she’d missed. Because she was finished with waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She forced a smile. “No going back. This is what I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The carriage door swung open. The liveried footman let down the steps. Diana resolutely stepped down into the warm spring evening. She glanced back at her auburn-haired friend. “Besides, he may not show up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate jumped down beside her. “He’ll be waiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good. Someone waiting for her for once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her stomach lurched. Why was she so nervous? It was only a meeting tonight. If she didn’t feel comfortable with the man, that would be an end to it. He might not like her and would have the same option. It was the terms they’d agreed. Was that her fear…that he would find her lacking? Mentally she shrugged. Nothing would be lost. The meeting would be a fleeting anonymous discussion. Her reputation would remain intact. She’d made sure of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Harry is already here?” she asked Kate, perhaps for the third time. Harry, Lord Godridge was the man who had swept Kate off her feet and carried her off to a wedding at Gretna Green. The couple had recently returned to London take Diana’s niece, Lizzie, back to her father in Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s here with Lizzie.” Kate chuckled. “Puzzled but content to be of service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They climbed the steps to the front door of the Dunstan’s palatial home on the bank of the Thames near Richmond. “Tonbridge is a good man,” Diana said wistfully. “His gain is my loss. I have yet to find a companion to replace you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Leaving you in the lurch is my only regret.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nonsense. I am fine.” Or she would be, once this terrible urgency to savor all life had to offer was gone from her blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The butler bowed them in and a footman took their cloaks. They shook out their skirts and patted their hair. Simple everyday things, yet Diana’s hands trembled as if she’d stepped on a loose rock at the edge of a precipice. Her heart beat so fast, she could feel blood rushing through her veins. Kate led the way down the corridor. Diana’s stomach tied itself in a knot as she followed, ostensibly going to the ladies’ withdrawing room. In truth, to an assignation that might forever change who she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They paused at an innocuous-looking panelled door, painted white. It stood slightly ajar. Waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate turned to face her. “This is it. Dunstan’s housekeeper was very precise in her directions. I’ll wait for you in the ballroom.” She hurried away, leaving Diana to make the final decision. Go in. Or leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was only a meeting. A prelude. An introduction. Nothing to fear at all. Drawing in a deep breath, she nodded and slipped inside. She let the door swing closed and stood with her back against it, waiting for her eyes to adjust to the dark. The light from the fire bounced off a polished wooden table. It gilded a sofa and a chair near the hearth. The rest of the room lay in shadow. Was he indeed here?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of the shadows shifted. “Good evening, madam,” a deep, pleasantly hoarse voice murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart leaped into her throat. She closed her lips on a gasp. The voice was not one she knew, though the quiet tone made it hard to be sure. But since she’d never met any of the men on her list, knowing them only by reputation, perhaps a brief glimpse during a whispered tale of wickedness, she was not surprised. She swallowed the dry lump in her throat. “Good evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bulky shadow drew close, so close she could feel his heat and inhale the dark note of his cologne. Something musky and very male.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hand touched hers, then held it. No gloves. Male skin brushed her fingertips, the warmth of his palm penetrated the lacy cotton of her evening mittens as he brought her hand to his lips. A light brush followed by a puff of warm air as he breathed. It sent tingles up her arm and all the way down to her toes. Her body tightened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Delicious sensations rippled across her skin even as his gentleness soothed. No longer was she afraid. Just delectably excited. The excitement of youth and life. “I apologize for the secrecy,” she said softly. “My reputation demands it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I understand,” he murmured. “Come. Sit. We will get to know each other a little and see where it leads.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” she said, breathless again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a stumble or two and some rueful chuckles from each of them, they found their way to a corner far from the fire. She could make out nothing of his face, though now and again she caught a glimmer of firelight in his eyes, and a flash of white teeth, yet she had an impression of youth, strength and manliness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He held her hand cradled in his warm one. Once more he brought it to his mouth and she felt the curve of his lips against her knuckles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She raised her other hand to touch his face, tracing a well-formed brow above a nose to be reckoned with. Continuing her exploration she found a lean strong jaw, smooth shaven, and a determined chin. She followed the line of his neck and rested her hand on a firm broad shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will I do?” he asked with laughter in his voice, but no trace of insult. “Perhaps this will tip the balance in my favor.”")])]), _c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His warm hand cupped her nape, a loose gentle hold, and then his lips touched hers, moved easily on her mouth, tasting her with a soft sigh that made her insides flutter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A melting sensation invaded her limbs. Dear heaven, she was leaning into him, pressing her tingling breasts against a solid wall of chest to ease their ache, clutching at those lovely broad shoulders and…kissing him back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their breaths tangled as she parted her lips. His tongue swept the inside of her mouth in a caress that dizzied her senses. Heat flared in her belly. Little waves of something pleasurable spread out from deep between her thighs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His other hand wandered her back, came around to stroke her ribs, brushed the underside of her breast. A tantalizing touch, arousing a wildness that made her moan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He broke away, his breathing ragged and harsh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She liked that she had some effect on him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dearest lady,” he murmured. “This is neither the time or the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her face flamed. Was she really so wanton she’d been prepared to bed him right here. It seemed so, for she whispered, “When? Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A soft laugh rumbled from his chest. Little bursts of heat trickled along her veins at the wickedness in the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our bargain is sealed, then?” His whisper, so close to her ear, sent a shiver down her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a deep breath. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Meet me at the masquerade at Vauxhall tomorrow evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate must have mentioned her plans. “Very well.” There…that sounded calm enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rose to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Panicked, she gazed up at him. “How will you find me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wear red. I will know you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Swift strides took him to the door. She had a glimpse of a tall lean form in the half light from the corridor outside, and he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana pressed her hands to her mouth, staring at the empty doorway. Just like that, it was done.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How would she get through tonight when excitement rushed through her veins like molten metal? How would she pretend nothing had happened? Pretend she had never been kissed like a wanton? Pretend she was naught but a dried-up spinster chaperoning her niece? Somehow she must.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Carefully she picked her way through the darkened room. Saw no one in the hallway. Heart skipping, she hurried into the ballroom. Was he here, her stranger? Somewhere in the room, watching, wondering which of the many women present had been in his arms but a moment ago? She pushed through the press of people and took the empty chair at Kate’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her friend raised a brow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana flushed hot and sent her a look of reproof.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then it is done?” Kate said. “Good for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was done. Finally she’d taken matters into her own hands. But now was not the time to think about it. Tomorrow would arrive soon enough. She buried her excitement beneath a calm smile. She glanced around the opulent marble-and-gilt ballroom. “The Duke of Dunstan certainly knows how to entertain on the grand scale.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m still reeling at the idea the dissolute duke is actually married,” Kate said with a swift glance at the duke and duchess speaking with a group of guests. The sartorially splendid duke had a bored smile on his thin lips. His duchess, a tall elegant woman, attired in a gown of gold tissue and the famous Dunstan rubies, looked thoroughly ill at ease. “Rumor has it he married to teach the dowager duchess a lesson.”")])]), _c('a', {
    attrs: {
      "id": "page04"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Knowing Dunstan’s reputation, I don’t doubt it for a moment,” Diana replied. There was something cold about the duke. “No wonder this ball is such a squeeze. Everyone wants a look at his choice of wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana caught a glimpse of Lizzie and Harry on the dance floor and smiled fondly at the blond-haired beauty who looked so much like Diana they could have been sisters. “I really am going to miss the dear child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate touched her hand with her fan and cast her a knowing smile. “No so much as you expected, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana’s stomach tumbled over. Heat scalded her cheeks. She glanced around. “Hush. Do you want the world to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No one could possibly guess,” her friend said. “Not about prim-and-proper you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prim and proper")]), _vm._v(" certainly described her life up to now. And look where it had got her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here comes Lord Grey,” Kate said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cheeks still hot, Diana stared at the lean man bearing down on them. Her heart gave an odd little thump. She’d known James for most of her life. He’d been as sports mad as her intended, Peter. Corinthians, they called themselves. Forever at some boxing match, or racing their horses or curricles. After Peter’s death, he’d given all that up. She’d watched him mature from a gangly heir to an earldom to a tall, athletic and confident lord of his lands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d been her most steadfast friend, helping her through her parents’ deaths and the quagmire of financial arrangements left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate narrowed her eyes. “He’s very handsome, but so stern.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was handsome. Not a fair Adonis like Peter, but his strong harsh features, the angled jaw and knife-edged cheekbones, spoke of determination and action. His large spare frame made her think of long rides in the country rather than games of chance in the gambling rooms at Whites. A stern-faced nobleman who did his duty to family and to those lucky enough to earn his friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am surprised he has never married,” Kate mused. “Would he do for you, do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana’s heart tumbled over. Once or twice she’d thought, well hoped really, he might have interest, but he’d not said a word. Over time she’d come to realize he viewed her as one of his duties. “He’s been like…like a brother.” He saw her as one of his responsibilities. Nothing more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you do like him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who would not like Lord Grey? He is an honorable gentleman.” Diana shifted in her chair, the conversation making her twitchy. With what? Yearning? If so, it was pure foolishness. She’d waited for years for Peter to finish sowing his wild oats, as her mother had called his antics on the hunting field and at Jackson’s boxing saloon. She wasn’t waiting for anyone anymore. She sighed a little sigh. “He has been a pillar these last few years and a good friend. Honestly, I believe, even after all this time he feels guilty about what happened to Peter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t his fault the fool rode neck or nothing to his death.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, of course it wasn’t,” she said crossly, not wanting to cover old ground. Heavens knew she did it often enough in her own mind. “It was Peter’s own doing. I know it and logically so does Grey. Yet he believes himself partly responsible. I really do not want to discuss this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate pursed her lips. “Then I will say no more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good. She hated talking about Peter. Only with James did she ever feel comfortable talking about what had happened. Over the years it had become a bond between them she would hate to lose.")])]), _c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he neared, she he held out her hand with a welcoming smile. “I thought you were out of town, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes warmed as he shook her hand. His touch was firm and comforting. A frisson of awareness on some deeper level ran through her. A sense of recognition she didn’t quite understand. A feeling almost as intense as that she’d experienced in the darkened room with the stranger. How could that be? Familiarity, she decided, as he made his bows to Kate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How is your mother, Lord Grey?” Diana asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His dark eyes rested on her face. They seemed to warm. “Well ensconced in Bath, I am happy to say. I intend to visit her later in the week and will carry any message you might have if you would like me to call for them in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That is most kind,” Diana said. “I expect to go to Bath myself later in the month. Once Lizzie has returned to her father.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grey frowned at where Lizzie was laughing at something Harry must have said as she tripped lightly down the set. “I thought she was to have left for Scotland weeks ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My fault, I’m afraid,” Kate said with a completely unrepentant smile. “Though you must agree, Lord Grey, Lizzie has become quite the rage. I should not be at all surprised to see a very advantageous marriage by next season. Lord Macrae must be pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have enjoyed every moment of her season,” Diana added, seeing Lord Grey’s frown deepen. “It made me feel young again. The house will seem quite empty when she goes.” And Diana would return to her old quiet life. Her pulse quickened. Or she would have, if it wasn’t for the step she had taken tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She inhaled a quick breath to repress another round of flutters in her stomach. “Well, Lord Grey, and what do you think of the happy couple?” She indicated the progress of the duke and the duchess around the room. “They say they met one day and married the next. Have you heard of anything more romantic?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He snorted. “Sounds more like a case of needs must to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diana shivered at the image. One night with a stranger and married the next day. So dark and dangerous. How could one not call that romantic? Gothically so. Tonight, for the first time, she had experienced some of that thrill. And she wanted more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lord Grey’s dark eyes narrowed. The irises were blue-flecked with brown. They reminded her of cool streams and deep pools of calm water, yet sometimes like now, they glowed as if there were banked fires deep beneath the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned hot, then cold. Goodness, surely she had not allowed her wicked thoughts to show on her face, not when James watched her so closely. As if he guessed. He could not. Not possibly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They do say reformed rakes make the best husbands,” Kate observed, her gaze fixed skeptically on the dissolute duke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If they reform,” James said dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t have an ounce of romance in your soul do you, Lord Grey?” Diana smiled to take the sting out of her words even as she heard the rather cutting edge in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes widened a fraction. “Not a smidgen,” he agreed, his gaze considering, and perhaps even a small smile playing about his lips as if he thought her notions ridiculous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She plied her fan vigorously to hide another burst of heat. “Let me tell you, there was nothing more romantic than seeing Kate being whisked off to Gretna Green by a highwayman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A highwayman, indeed,” Kate said, laughing. “Harry didn’t fool me for a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hard line of Lord Grey’s mouth softened into a smile. Diana’s heart caught at the too rare sight. She bit back the compulsion to ask why he didn’t smile more often. He used to smile as a youth, she remembered. And tease.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In those days he’d been as reckless as Peter. A sportsman. Up to every rig and row in Town and the devil take the hindmost. Until Peter died.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is it every woman’s fantasy to be carried off by a highwayman?” He looked down at her and her heart gave an odd sort of leap at the intensity in his gaze. She felt quite fluttery at the warmth she saw there. As fluttery as she had felt at the stranger’s kiss. Was she becoming so wanton? How embarrassed he would be if he knew. She swallowed. Took a breath. “I am sure I don’t know. Do you go to Vauxhall tomorrow? For the mask?” she asked, clumsily changing the subject. “It is Lizzie’s last night of entertainment before she goes home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stared at her for a long moment. The frisson of awareness struck her anew. As if something else ran beneath the surface of their conversation. Was she really so desperate that two such different men could fill her with longing all in one evening. Or was her fear of loneliness playing tricks with her mind and her body?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grey shook his head. “I am sorry. I am engaged for dinner with friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt a pang of disappointment. But if he knew what she intended tomorrow, he would be the one dreadfully disappointed. In her. Perhaps she was making a huge mistake. She could still cry off. Just not go. It was not as if anyone but herself and Kate would know what she’d planned. She still had time to change her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you ladies will excuse me,” Grey said. “I really must offer my congratulations to our hosts. May I take you into supper later, Miss Buntin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So thoughtful, as always. She smiled up at him. “Thank you. You are very kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mouth tightened as if the thought of his kindness did not please him. He bowed and strode away.")])])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a8094e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426852985_ch01.vue
// module id = 72
// module chunks = 0